import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
  apiKey: "AIzaSyBOLUbK5byVqVSNAeoOjqL6MkMb7bfIs9Y",
  authDomain: "yoga-dice-4c429.firebaseapp.com",
  databaseURL: "https://yoga-dice-4c429.firebaseio.com",
  projectId: "yoga-dice-4c429",
  storageBucket: "",
  messagingSenderId: "457427832692"
};

firebase.initializeApp(config);
firebase.firestore();

export default firebase;